import script from "./ChannelsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelsPage.vue?vue&type=style&index=0&id=a8e29f58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8e29f58"]])

export default __exports__